import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DriversWithdrawalRequestService {
  constructor(private http: HttpClient) {}

  getDriverWithdrawalReq(data: any) {
    return this.http.post(
      environment.apiUrl + "driver/withdrawalrequest/get",
      data
    );
  }

  updateDriverWithdrawalReq(data: any) {
    return this.http.post(
      environment.apiUrl + "driver/withdrawalrequest/update",
      data
    );
  }

  searchWalletRequest(data: any) {
    return this.http.post(
      environment.apiUrl + "driver/withdrawalrequest/search",
      data
    );
  }
}
